// extracted by mini-css-extract-plugin
module.exports = {"languageMessageWrapper":"LanguageMessage_languageMessageWrapper__65hkw","languageMessage_noFilterResults":"LanguageMessage_languageMessage_noFilterResults__JsDUV"};